export const task = {
  index: {
    title: 'Tasks'
  },

  field: {
    id: 'ID',
    number: 'Number',
    caller_id: 'Caller ID',
    priority: 'Priority',
    attempts: 'Position in the strategy',
    strategy: 'Position in the strategy',
    start: 'Order created at',
    status: 'Status',
    last_attempt: 'Last attempt',
    next_attempt: 'Next attempt',
    created_at: 'Order created at',
    lead_date: 'Task created at',
    delayed_until: 'Delayed until',
    additionally: 'Additionally'
  },

  state: {
    title: 'Status',
    success: 'Success',
    processing: 'Processing',
    canceled: 'Canceled',
    pending: 'Pending',
    fail: 'Fail'
  },

  tooltips: {
    strategy:
      'The specified value will determine from what stage of the strategy the dialing attempts will be made.',
    caller_id:
      'If the field is left blank, the task will be assigned the Caller ID specified when creating the campaign.',
    delayed_until: 'Time is in UTC +00:00',
    additionally: 'The field represents any additional information that will be passed to the hook.'
  },

  warnings: {
    skills:
      'Operator skills will not be taken into account. The "Take into account operator skills" option is not selected in the campaign settings.'
  },

  button: {
    create: 'Create task'
  },

  modal: {
    create: 'Create task',
    import: 'Import tasks',
    import_hint:
      'Make sure the numbers in the file are in international format. For example, +7ХХХХХХХХХ.'
  }
};
